<template>
  <b-input
    :data-test-id="
      'revenueInput_'
        .concat(String(props.shopId))
        .concat('_')
        .concat(String(props.sectionId))
    "
    ref="inputRef"
    inputmode="numeric"
    position="is-right"
    :disabled="isDisabled"
    :placeholder="revenueValuePlaceHolder(isDisabled)"
    @keydown.up.prevent.native
    @keydown.down.prevent.native
    :validation-message="t('OnlyIntegerAllowed')"
  />
</template>

<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { CurrencyDisplay, useCurrencyInput } from "vue-currency-input"

const props = defineProps<{
  modelValue?: number | null
  sectionId: number
  shopId: number
  isDisabled: boolean
  revenueExists: boolean
  locale: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: number | null | undefined): void
  (e: 'change', value: number | null | undefined): void
}>()

const { t } = useI18n()

const { inputRef, numberValue, setValue } = useCurrencyInput({
  currency: 'NIS',
  currencyDisplay: CurrencyDisplay.hidden,
  locale: props.locale,
  precision: 2,
  valueRange: { min: 0, max: undefined },
  hideCurrencySymbolOnFocus: false,
  hideGroupingSeparatorOnFocus: false,
  hideNegligibleDecimalDigitsOnFocus: false,
  useGrouping: true
})

// Keep an explicit runtime read so TS doesn't flag inputRef as unused.
void inputRef

onMounted(() => {
  setValue(props.modelValue || 0)
})

// Watch for external value changes
watch(() => props.modelValue, (newValue) => {
  if (newValue !== numberValue.value) {
    setValue(newValue || 0)
  }
})

// Watch for input changes and emit to parent
watch(numberValue, (newValue) => {
  emit('update:modelValue', newValue)
})

const revenueValuePlaceHolder = (isDisabled: boolean): string => {
  return isDisabled
    ? t("IsDisabled")
    : props.revenueExists
    ? t("RevenueExists")
    : t("InsertRevenueWithoutVat")
}
</script>
